
class PageQuestionAPI {
    update(pageQuestion) {
        const endpoint = `/api/survey/${this.surveyId}/pageQuestion/${pageQuestion.id}`
        return this.store.http.put(endpoint, JSON.stringify(pageQuestion.currentOptions), this.store.surveyToken)
            .then((res) => {
                console.log(`done ${res}`)
                this.store.survey.refreshSkipLogic(this.store)
                this.store.addNotification({ body: 'Question updated', level: 'success' })
                return res
            }).catch((e) => {
                console.log(e)
                this.store.handleError({ body: `Error updating question: ${e.message}`, level: 'error' })
            })
    }
}

export default new PageQuestionAPI()